import black from './logo_black.svg'
import white from './logo_white.svg'
import house_illustration from './illustrations/house.png'
import location from './illustrations/location.png'
import lock from './illustrations/lock.png'
import check from './icons/Check.png'
import search from './icons/Search.png'
import arrow_down from './icons/Arrow_Down.png'
import play from './icons/Play.png'
import hero from './images/heroImage.png'
import ivy from './images/Ivy.png'
import about from './images/House.png'
import rexona from './images/Rexona.png'
import palace from './images/Palace.png'

export const Hero = hero;
export const About = about;
export const House = house_illustration;
export const Location = location;
export const Lock = lock;
export const Check = check;
export const Ivy = ivy;
export const Rexona = rexona;
export const Palace = palace;
export const Search = search;
export const Arrow_Down = arrow_down;
export const Play = play;
export const White = white;
export const Black = black;
